module.exports = __webpack_public_path__ + "img/chevron-right-orange.0d8cdaa2.svg";